import { Outlet } from '@tanstack/react-router';

import { FeatureNotEnabledView } from 'common/components/cookbook/FeatureNotEnabledView/FeatureNotEnabledView';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSelectedWarehouse } from 'common/hooks/useSelectedWarehouse';
import { useTaskManagementEnabled } from 'common/task-management/useTaskManagementEnabled';

const TaskManagementEnabledRoute = () => {
  const f = useFormatMessage();
  const warehouseId = useSelectedWarehouse().id;
  const enabled = useTaskManagementEnabled(warehouseId);
  const viewTitle = f('task_management.tasks');

  if (enabled) {
    return <Outlet />;
  }

  return (
    <FeatureNotEnabledView
      viewTitle={viewTitle}
      description={f('warehouse.common.feature_not_enabled')}
    />
  );
};

export default TaskManagementEnabledRoute;
